import { AuthRegisterState, AuthRegisterAction, AuthLoginState, AuthLoginAction, AuthForgotPasswordState, AuthForgotPasswordAction, IAuthUserCurrent, AuthUserCurrentAction } from '../../models'
import { authConstants } from '../constants'

const registerInitialState = {
  patient: {
    document_type_id: 0,
    document_number: '',
    first_name: '',
    last_name: '',
    second_name: '',
    date_birth: '',
    nationality_id: 0,
    forecast_id: 0,
    gender_id: 0,
    email: '',
    region_id: 0,
    city_id: 0,
    commune_id: 0,
    address: '',
    phone: '',
    password: ''
  }
}

const loginInitialState = {
  patient: {
    document_type_id: 0,
    document_number: '',
    password: ''
  }
}

const fortotPasswordInitialState = {
  patient: {
    document_type_id: 0,
    document_number: ''
  }
}

const getUserCurrentStorageState = {
  info: {
    id: 0,
    document_type_id: 0,
    document_number: '',
    first_name: '',
    last_name: '',
    second_name: '',
    date_birth: '',
    nationality_id: 0,
    forecast_id: 0,
    gender_id: 0,
    email: '',
    address: '',
    phone: '',
    commune_id: 0,
    image_store_id: '',
    image_store_passport: '',
    image_store_passport_patient: '',
    status_passport: false,
    date_creation: '',
    status: '',
    role: ''
  },
  token: ''
}

const register = (state: AuthRegisterState = registerInitialState, action: AuthRegisterAction) => {
  switch (action.type) {
    case authConstants.REGISTER_REQUEST:
      return {
        type: 'REQUEST',
        patient: action.patient,
        error: null
      }
    case authConstants.REGISTER_SUCCESS:
      return {
        type: 'SUCCESS',
        patient: action.patient
      }
    case authConstants.REGISTER_FAILURE:
      return {
        type: 'ERROR',
        error: action.error
      }
    default:
      return state
  }
}

const login = (state: AuthLoginState = loginInitialState, action: AuthLoginAction) => {
  switch (action.type) {
    case authConstants.LOGIN_REQUEST:
      return {
        type: 'REQUEST',
        patient: action.patient,
        error: null
      }
    case authConstants.LOGIN_SUCCESS:
      return {
        type: 'SUCCESS',
        patient: action.patient
      }
    case authConstants.LOGIN_FAILURE:
      return {
        type: 'ERROR',
        error: action.error
      }
    default:
      return state
  }
}

const forgotPassword = (state: AuthForgotPasswordState = fortotPasswordInitialState, action: AuthForgotPasswordAction) => {
  switch (action.type) {
    case authConstants.FORGOTPASSWORD_REQUEST:
      return {
        type: 'REQUEST',
        patient: action.patient,
        error: null
      }
    case authConstants.FORGOTPASSWORD_SUCCESS:
      return {
        type: 'SUCCESS',
        patient: action.patient
      }
    case authConstants.FORGOTPASSWORD_FAILURE:
      return {
        type: 'ERROR',
        error: action.error
      }
    default:
      return state
  }
}

const userCurrentStorage = (state: IAuthUserCurrent = getUserCurrentStorageState, action: AuthUserCurrentAction) => {
  switch (action.type) {
    case authConstants.GET_USER_CURRENT_STORAGE:
      return {
        ...action.currentUser
      }
    default:
      return state
  }
}

export {
  register,
  login,
  forgotPassword,
  userCurrentStorage
}